import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Bookmark } from "../../Assets/Icons/Bookmark.svg";
import { ReactComponent as CancerLogo } from "../../Assets/Icons/CancerLogo.svg";
import { ReactComponent as SliderIcon } from "../../Assets/Icons/SliderIcon.svg";
import { ReactComponent as Settings } from "../../Assets/Icons/Settings.svg";
import { ReactComponent as Logouts } from "../../Assets/Icons/Logouts.svg";
import { motion } from "framer-motion";

import {
  FilterBox,
  LogoContainer,
  MainContainer,
  ProfileAndBookMarkContainer,
  RightSection,
  TextContaier,
  SubTitle,
  Title,
  BookmarkContainer,
  HospitalComparisonContainer,
  Badge,
  ProfileDetailsContainer,
  InternalContainer,
  ProfileAbbrBox,
  ProfileNameBox,
  Details,
  Buttons,
  ReleaseNotesButton,
  ContentContainer,
} from "./index.styled";
import SearchBox from "../SearchBox";
import Popup from "../Popup";
import { BackgroundOverlay } from "../FilterComp/index.styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearProviderNumbers,
  setGlobalSearchReset,
  setHospitalsDetails,
  setIsBookmarkTable,
} from "../../Redux/app/app.actions";
import {
  resetSelectedState,
  resetSpecificStateData,
} from "../../Redux/hospital/hospital.actions";
import { useBookmarks } from "../../hooks/useBookmarks";
import { views } from "../../Configs/config";
import Info from "../Info";
import PartnerExclusiveCheckbox from "../PartnerExclusiveCheckbox";
import { useSnack } from "../SnackBar";
import { formatBookmarkData } from "../../utils";
import { logoutUserApi } from "../../Redux/auth/auth.actions";
import { setSortingModelVisibility } from "../../Redux/sortingModel/sortingModel.actions";

const Header = ({
  state,
  toggleState,
  handleClosePopup,
  resetFlag,
  setResetFlag,
  isVisible,
}) => {
  const { rawBookmarksData, bookmarkList, bookmarkListLoaded } = useSelector(
    (state) => state.bookmarks,
  );
  // Fetch (once, cached) + mirror bookmarks into Redux for all consumers.
  useBookmarks();
  const { compareHospitals } = useSelector((state) => state.compare);
  const compareHospitalsCount = compareHospitals.filter((h) =>
    Number(h.provider_number),
  ).length;
  const [isDownloadDropdownOpen, setIsDownloadDropdownOpen] = useState(false);
  const [data, setData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const snack = useSnack();
  const [bookmarksTableList, setBookmarksTableList] = useState([]);
  const location = useLocation();
  const isRootPath = location.pathname === "/";
  const [isHovered, setIsHovered] = useState(false);
  const [isBookMarkHovered, setIsBookMarkHovered] = useState(false);
  const [isNSDropdownOpen, setIsNSDropdownOpen] = useState(false);

  const nsRef = useRef(null);

  // Clicking the logo is a full reset: drop EVERY query param (global filter
  // dropdown, quick filter, advanced filters, map/legend selection, state, sort
  // and view) and land on a clean homepage. With no `view` param the homepage
  // falls back to the default map view.
  const goHomeResettingFilters = () => {
    navigate("/");
  };

  const navigateToHome = () => {
    if (state.isPopupVisible) toggleState("isPopupVisible");
    // The view is set by goHomeResettingFilters() navigating to view=map.
    dispatch(
      setHospitalsDetails({
        view: views.MAP,
        filterFlag: false,
        data: [],
        tableTitle: "",
        isBookmarkData: false,
        totalCount: 0,
        // isGraphCellClicked: false,
      }),
    );
    dispatch(resetSelectedState());
    dispatch(resetSpecificStateData());
    dispatch(setGlobalSearchReset(false));
    dispatch(setIsBookmarkTable(true));
    dispatch(clearProviderNumbers());
    dispatch(setSortingModelVisibility(false));
    setResetFlag(true);
    goHomeResettingFilters();
  };

  useEffect(() => {
    if (bookmarkListLoaded && rawBookmarksData?.length > 0) {
      const { bookmarksList, options, hospitalDetailsArray } =
        formatBookmarkData(rawBookmarksData);
        setBookmarksTableList(hospitalDetailsArray);
        setData({ bookmarksList, options });
    }
  }, [bookmarkListLoaded, rawBookmarksData]);

  const popupRef = useRef(null);
  const bookmarkRef = useRef(null);

  const handleLogout = () => {
    dispatch(logoutUserApi());
    navigate("/sign-in");
  };

  const handleReleaseNotes = () => {
    window.open("/release-notes", "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (nsRef.current && !nsRef.current.contains(event.target)) {
        setIsNSDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        bookmarkRef.current &&
        !bookmarkRef.current.contains(event.target)
      ) {
        toggleState("isPopupVisible", false); // Close the popup
      }
    };

    if (state.isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [state.isPopupVisible]);

  const handleBookmarkClick = () => {
    toggleState("isPopupVisible", !state.isPopupVisible);
  };
  return (
    <>
      {state.isPopupVisible && (
        <BackgroundOverlay
          onClick={() => {
            handleClosePopup();
            setIsDownloadDropdownOpen(false);
          }}
        />
      )}
      <motion.div
        initial={false}
        animate={isVisible ? "visible" : "hidden"}
        variants={{
          visible: {
            opacity: 1,
            y: 0,
            pointerEvents: "auto",
            transition: {
              duration: 0.3,
              ease: "easeInOut",
            },
          },
          hidden: {
            opacity: 0,
            y: -8,
            pointerEvents: "none",
            transition: {
              duration: 0.3,
              ease: "easeInOut",
            },
          },
        }}
        style={{ width: "100%" }}
      >
        <MainContainer>
          <LogoContainer onClick={navigateToHome}>
            <CancerLogo />
            <TextContaier>
              <Title>P.A.T.H</Title>
              <SubTitle>Partner Assessment Tool for Healthcare</SubTitle>
            </TextContaier>
          </LogoContainer>
          <RightSection>
            <SearchBox
              placeholder="Search Hospitals, State, County, Zip..."
              state={state}
              toggleState={toggleState}
            />
            {/* Popup for bookmark */}
            {
              <div ref={popupRef}>
                <Popup
                  isPopupVisible={state.isPopupVisible}
                  isTableVisible={state.isTableVisible}
                  togglePopup={toggleState}
                  isDropdownOpen={isDownloadDropdownOpen}
                  setIsDropdownOpen={setIsDownloadDropdownOpen}
                  bookmarkList={bookmarkList}
                  data={data}
                  bookmarksTableList={bookmarksTableList}
                  resetFlag={resetFlag}
                  setResetFlag={setResetFlag}
                />
              </div>
            }
            <ProfileAndBookMarkContainer>
              {!state.isTableVisible && isRootPath && (
                <Info
                  showArrow={false}
                  config={{
                    tooltipText: "Partner Exclusive Areas",
                    position: "top",
                    offsetY: 15,
                  }}
                >
                  <PartnerExclusiveCheckbox />
                </Info>
              )}
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Compare Screen",
                  position: "top",
                  offsetY: 15,
                }}
              >
                <HospitalComparisonContainer
                  onClick={() => {
                    if (compareHospitals.length === 1) {
                        snack(
                          "Select at least two hospitals to compare!",
                          "#FFC640",
                          "#333333"
                        );
                        return;
                      }
                    dispatch(
                      setHospitalsDetails({
                        view: views.MAP,
                        filterFlag: false,
                        data: [],
                        tableTitle: "",
                      }),
                    );
                    dispatch(resetSelectedState());
                    dispatch(resetSpecificStateData());
                    dispatch(setGlobalSearchReset(false));
                    dispatch(clearProviderNumbers());
                    // Open compare via a single URL write (App.toggleState sets
                    // view=compare, routing home first if needed). Works from
                    // both map and table since it no longer relies on resetFlag.
                    toggleState("isTableVisible");
                  }}
                  isTableVisible={state.isTableVisible}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  isHovered={isHovered}
                >
                  {compareHospitalsCount > 0 && (
                    <Badge>
                      <div> {compareHospitalsCount || 0} </div>
                    </Badge>
                  )}
                  <SliderIcon
                    style={{
                      stroke: isHovered ? "#F96C50" : "#333333",
                    }}
                  />
                </HospitalComparisonContainer>
              </Info>
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Bookmarks",
                  position: "top",
                  offsetY: 15,
                }}
              >
                <BookmarkContainer
                  ref={bookmarkRef}
                  onClick={handleBookmarkClick}
                  isPopupVisible={state.isPopupVisible}
                  onMouseEnter={() => setIsBookMarkHovered(true)}
                  onMouseLeave={() => setIsBookMarkHovered(false)}
                  isHovered={isHovered}
                >
                  {bookmarkList?.length > 0 && (
                    <Badge>
                      <div> {bookmarkList?.length || 0} </div>
                    </Badge>
                  )}
                  <Bookmark
                    style={{
                      stroke: state.isPopupVisible
                        ? ""
                        : isBookMarkHovered
                          ? "#F96C50"
                          : "#333333",
                      fill: state.isPopupVisible ? "#F6B51C" : "none",
                      color: state.isPopupVisible ? "#F6B51C" : "#333333",
                    }}
                  />
                </BookmarkContainer>
              </Info>
              <div ref={nsRef} style={{ position: "relative" }}>
                <FilterBox
                  fontSize={"1.2"}
                  onClick={() => setIsNSDropdownOpen((prev) => !prev)}
                >
                  NS
                </FilterBox>
                <ProfileDetailsContainer isVisible={isNSDropdownOpen}>
                  <InternalContainer>
                    <ContentContainer>
                      <ProfileAbbrBox>NS</ProfileAbbrBox>
                      <ProfileNameBox>
                        <Details fontSize={1} fontWeight={700}>
                          Nathan Suszanski
                        </Details>
                        <Details
                          fontSize={0.8125}
                          fontWeight={400}
                          opacity={"60%"}
                        >
                          NGSuszanski@mdanderson.org
                        </Details>
                      </ProfileNameBox>
                    </ContentContainer>
                    <ContentContainer>
                      <ReleaseNotesButton onClick={handleReleaseNotes}>
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#333333"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="8" y1="13" x2="16" y2="13" />
                          <line x1="8" y1="17" x2="13" y2="17" />
                        </svg>
                        Release Notes
                      </ReleaseNotesButton>
                    </ContentContainer>
                    <ContentContainer>
                      <Buttons isDisabled>
                        <Settings />
                        Settings
                      </Buttons>
                      <Buttons onClick={handleLogout}>
                        <Logouts />
                        Log Out
                      </Buttons>
                    </ContentContainer>
                  </InternalContainer>
                </ProfileDetailsContainer>
              </div>
            </ProfileAndBookMarkContainer>
          </RightSection>
        </MainContainer>
      </motion.div>
    </>
  );
};

export default Header;
